import { Kit } from "@/types/types";
import { BasicKitQuickSettings } from "./BasicKitQuickSettings";
import { ConversationKitQuickSettings } from "./ConversationKitQuickSettings";
import { ExpertKitQuickSettings } from "./ExpertKitQuickSettings";
import { ProjectKitQuickSettings } from "./ProjectKitQuickSettings";
import { SkillKitQuickSettings } from "./SkillKitQuickSettings";
import { TemplateKitQuickSettings } from "./TemplateKitQuickSettings";

type KitQuickSettingsMenuProps = {
  kit: Kit;
};

export const KitQuickSettingsMenu = ({ kit }: KitQuickSettingsMenuProps) => {
  switch (kit.type) {
    case "interview":
    case "project_preset":
      return <BasicKitQuickSettings kit={kit} />;
    case "conversation":
      return <ConversationKitQuickSettings kit={kit} />;
    case "project":
      return <ProjectKitQuickSettings kit={kit} />;
    case "expert":
      return <ExpertKitQuickSettings kit={kit} />;
    case "skill":
      return <SkillKitQuickSettings kit={kit} />;
    case "template":
      return <TemplateKitQuickSettings kit={kit} />;
    default:
      return null;
  }
};
